import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { DTODiffusionModelsTableBase } from '@shared/dto/+diffusion_model/_base/table/dto_diffusion_model_table_base';
import { useTranslation } from 'react-i18next';
import { EPageDiffusionModelsFilterBaseModel } from '../enums/e_page_diffusion_models_filter_base_models';

interface Props {
  value: string;
  value_selected: string;
  current_table: DTODiffusionModelsTableBase;
  on_value_change: (value: string) => void;
}

export function DiffusionModelsFilterListBaseModelItem({ value, value_selected, current_table, on_value_change }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const items_amount = get_items_amount();

  const is_disabled = items_amount === 0 && value !== EPageDiffusionModelsFilterBaseModel.ALL;
  /*
   * EVENTS
   */

  function on_value_change_internal() {
    if (is_disabled) return;

    on_value_change(value);
  }

  /*
   * METHODS
   */

  function get_items_amount() {
    let out = 0;

    if (current_table.is_stub()) {
      //do nothing
    } else if (value === EPageDiffusionModelsFilterBaseModel.ALL) {
      out = current_table.items_amount_by_base_model_all;
    } else {
      out = current_table.items_amount_by_base_model_map.get_or_default(value, 0);
    }

    return out;
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <div
      onClick={on_value_change_internal}
      className={`flex text-page-foreground items-center hover:bg-component-item-selected h-[32px] px-4 rounded-lg
            ${value_selected === value ? 'bg-component-item-selected' : 'bg-component'}
            ${is_disabled ? 'justify-start opacity-50 cursor-pointer-ban' : 'justify-between cursor-pointer'} `}
      key={value}
    >
      <span>{value === EPageDiffusionModelsFilterBaseModel.ALL ? t(i18n_page_diffusion_models.list.model_base.rows.ALL) : value}</span>
      {items_amount === 0 ? <></> : <span className="border border-component-border rounded-lg bg-component px-2">{items_amount}</span>}
    </div>
  );
}
